import SiblingBrandsSettingsTab from './sibling-brands-settings';

export default SiblingBrandsSettingsTab;
